/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CancellationRequestResponse,
  CreateCancellationRequestRequest,
  EnhancedSubscriptionResponse,
  HTTPValidationError
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Get the current subscription for the authenticated member.

Returns subscription with enhanced status:
- If no cancellation request exists: returns original status
- If active cancellation request exists: returns status as "cancellation_pending"
- If resolved cancellation request exists: returns original status
 * @summary Get Subscriptions
 */
export const getSubscriptionsV1SubscriptionsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<EnhancedSubscriptionResponse>(
      {url: `/v1/subscriptions`, method: 'GET', signal
    },
      );
    }
  

export const getGetSubscriptionsV1SubscriptionsGetQueryKey = () => {
    return [`/v1/subscriptions`] as const;
    }

    
export const getGetSubscriptionsV1SubscriptionsGetQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionsV1SubscriptionsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>> = ({ signal }) => getSubscriptionsV1SubscriptionsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSubscriptionsV1SubscriptionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>>
export type GetSubscriptionsV1SubscriptionsGetQueryError = unknown


export function useGetSubscriptionsV1SubscriptionsGet<TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSubscriptionsV1SubscriptionsGet<TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSubscriptionsV1SubscriptionsGet<TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Subscriptions
 */

export function useGetSubscriptionsV1SubscriptionsGet<TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSubscriptionsV1SubscriptionsGetQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a new subscription cancellation request.

This endpoint:
1. Checks for existing active cancellation requests
2. Creates/retrieves an Intercom contact for the member
3. Creates an Intercom support ticket
4. Stores the cancellation request in the database

Returns 409 Conflict if an active (unresolved) cancellation request already exists.
 * @summary Create Cancellation Request
 */
export const createCancellationRequestV1SubscriptionCancellationRequestsPost = (
    createCancellationRequestRequest: CreateCancellationRequestRequest,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<CancellationRequestResponse>(
      {url: `/v1/subscription-cancellation-requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCancellationRequestRequest, signal
    },
      );
    }
  


export const getCreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>, TError,{data: CreateCancellationRequestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>, TError,{data: CreateCancellationRequestRequest}, TContext> => {

const mutationKey = ['createCancellationRequestV1SubscriptionCancellationRequestsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>, {data: CreateCancellationRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  createCancellationRequestV1SubscriptionCancellationRequestsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>>
    export type CreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationBody = CreateCancellationRequestRequest
    export type CreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationError = HTTPValidationError

    /**
 * @summary Create Cancellation Request
 */
export const useCreateCancellationRequestV1SubscriptionCancellationRequestsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>, TError,{data: CreateCancellationRequestRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>,
        TError,
        {data: CreateCancellationRequestRequest},
        TContext
      > => {

      const mutationOptions = getCreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    